import { defineStore } from 'pinia'
import { ref } from 'vue'
import { formatDate, findDayAfterToday } from 'Utilities'

export const useReservationForm = defineStore('ReservationForm', () => {
  const today = new Date()
  const nextDay = new Date()
  nextDay.setDate(today.getDate() + 1)

  const adults = ref(2)
  const children = ref(0)
  const childAges = ref([])
  const chatID = ref(null)
  const hotelName = ref(null)
  const price = ref(null)
  const smoking = ref(false)
  const startDate = ref(formatDate(today, 'yyyy-MM-dd'))
  const endDate = ref(formatDate(nextDay, 'yyyy-MM-dd'))
  const payload = ref({
    adults: 1,
    children: 0
  })

  function increaseReservationFormAdults() {
    if (adults.value < 20) {
      adults.value += 1
      payload.value.adults_number++
    }
  }

  function decreaseReservationFormAdults() {
    if (adults.value > 1) {
      adults.value--
      payload.value.adults_number--
    }
  }

  function increaseReservationFormChildren() {
    if (children.value < 10) {
      children.value += 1
      payload.value.kids_number++
    }
  }

  function decreaseReservationFormChildren() {
    if (children.value > 0) {
      children.value--
      payload.value.kids_number--
    }
  }

  function pushReservationFormChildrenAges() {
    childAges.value.push(0)
  }

  function removeReservationFormChildAges() {
    childAges.value.splice(-1, 1)
  }

  function setDefaultSearchSetting(payload) {
    if (payload !== undefined) {
      adults.value = payload.adults
      startDate.value = formatDate(findDayAfterToday(payload.checkin_date_offset))
      endDate.value = formatDate(findDayAfterToday(payload.checkin_date_offset + 1))
    }
  }

  function setInitialReservationForm(initialValues) {
    adults.value = initialValues.adults || 1
    children.value = initialValues.children || 0
    childAges.value = initialValues.childAges || []
    chatID.value = initialValues.chatID || null
    hotelName.value = initialValues.hotelName
    price.value = initialValues.price
    smoking.value = initialValues.smoking || false
    startDate.value = initialValues.startDate
    endDate.value = initialValues.endDate
    payload.value = initialValues.payload || {}
  }

  function setReservationFormDates(payload) {
    startDate.value = payload.startDate
    endDate.value = payload.endDate
  }

  function toggleReservationFormSmoking() {
    smoking.value = !smoking.value
  }

  function updateReservationFormChildAges({ index, value }) {
    childAges.value[index] = value
  }

  function updateReservationFormPayload() {
    payload.value.checkin_date = startDate.value
    payload.value.checkout_date = endDate.value
    payload.value.adults_number = adults.value
    payload.value.kids_number = children.value
    payload.value.kids_ages = childAges.value
    payload.value.smoking = smoking.value
  }

  return {
    adults,
    children,
    childAges,
    chatID,
    hotelName,
    price,
    smoking,
    startDate,
    endDate,
    payload,

    increaseReservationFormAdults,
    decreaseReservationFormAdults,
    increaseReservationFormChildren,
    decreaseReservationFormChildren,
    pushReservationFormChildrenAges,
    removeReservationFormChildAges,
    setDefaultSearchSetting,
    setInitialReservationForm,
    setReservationFormDates,
    toggleReservationFormSmoking,
    updateReservationFormChildAges,
    updateReservationFormPayload
  }
})
